module.exports = __webpack_public_path__ + "img/快速回升-底图.e4871c95.png";